import React from "react";
import Svg from "./svg";

export default class MedangelIcon extends Svg {
    render() {
        return (
            <svg className="close-icon"
                 width="18"
                 height="16"
                 enableBackground="new 0 0 32 32"
                 version="1.1"
                 viewBox="0 0 64 10"
                 xmlSpace="preserve"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlnsXlink="http://www.w3.org/1999/xlink">

                    <path d="M17.238.446L.119 30.65c-.337.598.081 1.344.752 1.344h6.9c.31 0 .597-.168.752-.443L22.186 7.461a.904.904 0 0 0 0-.898L18.74.446a.857.857 0 0 0-1.503 0zM24.1 30.672l3.134-5.787a.87.87 0 0 1 .76-.458h5.924c.67 0 1.09-.75.752-1.344l-3.913-6.903a.856.856 0 0 0-1.5 0l-8.726 15.377a.863.863 0 0 1-.752.443h-6.896c-.67 0-1.09-.75-.752-1.344L29.253.443a.86.86 0 0 1 1.504 0l17.122 30.213c.337.598-.081 1.344-.752 1.344H24.86c-.662 0-1.08-.734-.76-1.328z" fill="#0093DA"/>
            </svg>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/svg/medangel.js
 **/